import React from 'react';
import GenericTabs from 'components/navigation/Tabs/Tabs';
import { NsKey } from 'enums/NsKey';
import { useConfigTabs } from 'components/navigation/Tabs/useConfigTabs';
import { BranchCode } from 'api/risk';
import { ContractBillingProvider, useContractBillingState } from './ContractBillingContext';
import { ReceiptTypeBadge } from 'components/domain';

interface ContractBillingProps {
  branchCode: BranchCode;
  contractId: string;
}

const ContractBillingContent: React.FC = () => {
  const { tabs, receiptType } = useContractBillingState();

  const {
    activeTab,
    setActiveTab,
    visibleTabs,
    getTabLabel
  } = useConfigTabs(tabs, {
    defaultTab: 1,
    translationNamespaces: [NsKey.Contract, NsKey.Common],
  });

  return (
    <div className='border rounded-xl px-4 py-2'>
      {/* Le type de quittance vaut pour tout l'échéancier : il se lit au-dessus des
          onglets plutôt que répété sur chaque ligne. */}
      {receiptType && (
        <div className='flex items-center gap-2 pb-2 pt-1'>
          <span className='text-xs font-medium text-gray-500'>Type de quittance</span>
          <ReceiptTypeBadge receiptType={receiptType} />
        </div>
      )}
      <GenericTabs defaultTab={activeTab} onChange={setActiveTab}>
        {/* Génération dynamique des onglets */}
        {visibleTabs.map(tab => (
          <GenericTabs.Item
            key={tab.id}
            label={getTabLabel(tab)}
            value={tab.id}
            disabled={tab.disabled}
            className="flex justify-center font-semibold w-full"
          />
        ))}
        {/* Génération dynamique du contenu */}
        {visibleTabs.map(tab => (
          <GenericTabs.Content key={tab.id} value={tab.id}>
            <div className='p-4'>
              {tab.content}
            </div>
          </GenericTabs.Content>
        ))}
      </GenericTabs>
    </div>
  );
};

const ContractBilling: React.FC<ContractBillingProps> = ({ branchCode, contractId }) => {
  return (
    <ContractBillingProvider branchCode={branchCode} contractId={contractId}>
      <ContractBillingContent />
    </ContractBillingProvider>
  );
};

export default ContractBilling;
